import { QueryProvider } from '@shared/providers';

import type { ReactNode } from 'react';

/**
 * Root providers, kept in one place and mounted outside the router so query
 * state survives navigation.
 *
 * When HeroUI v2 components are introduced, wrap children in `<HeroUIProvider>`
 * from `@veevarts/design-system` here (outermost), matching the portal's
 * provider order (ADR-0009).
 */
export function Providers({ children }: { children: ReactNode }) {
    return <QueryProvider>{children}</QueryProvider>;
}
